import { render, staticRenderFns } from "./invoice-excess-new.vue?vue&type=template&id=c5c3f2de"
import script from "./invoice-excess-new.vue?vue&type=script&lang=js"
export * from "./invoice-excess-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports